import { put, call, all, takeEvery, delay, select } from "redux-saga/effects";
import capcourseActions from "./actions";
import commonActions from "../common/actions";
import axios from "axios";
// import { API_URL } from "../../utils/constants";
import { calculateDaysDifference, formatDate } from "../../utils/validations";
import { EncryptFunction } from "../../utils/cryptoFunction";
import {
  handleDecodeJSON,
  handleEncodeJson,
} from "../../utils/encodeDecodeJson";
import candidatesActions from "../candidates/actions";

const capcoursesaga = function* () {
  yield all([
    yield takeEvery(capcourseActions.GET_ALL_CAPCOURSE, getallcapCourse),
    yield takeEvery(capcourseActions.GET_SCOREDETAILS, getscoredetails),
    yield takeEvery(capcourseActions.GET_CAP_CANDIDATEDETAILS, getcapcandidatedetails),
    yield takeEvery(capcourseActions.GET_CAP_CANDIDATEADDRESSDETAILS, getcapcandidateaddressdetails),
    yield takeEvery(capcourseActions.GET_CAP_CANDIDATEACADAMICDETAILS, getcapcandidateacademicdetails),
    yield takeEvery(capcourseActions.GET_CAP_CANDIDATERESERVATIONDETAILS, getcapcandidatereservationdetails),
    yield takeEvery(capcourseActions.GET_CAP_CANDIDATEUPLOADDETAILS, getcapcandidateuploaddetails),
    yield takeEvery(capcourseActions.GET_CAP_CANDIDATE_DOCUMENTS, getCapCandidateDocuments),

    yield takeEvery(capcourseActions.CAP_UPLOADS_DOCUMENTS_CREATION, createCapUploadsDocuments),
    yield takeEvery(capcourseActions.CAP_UPLOADS_DOCUMENTS_REMOVE, removeCapUploadsDocuments),


    yield takeEvery(capcourseActions.GET_CAP_CATEGORY, getCapCategories),
    yield takeEvery(capcourseActions.GET_CAP_CANDIDATURE, getCapCandidatures),
    yield takeEvery(capcourseActions.INSERT_CAP_CANDIDATURE, InsertCandidatedetails),

    yield takeEvery(capcourseActions.UPDATE_CAP_CANDIDATE_PERSONAL, capCoursePersonaldetailsUpdate),
    yield takeEvery(capcourseActions.UPDATE_CAP_CANDIDATE_ADDRESS, capCourseAddressUpdate),
    yield takeEvery(capcourseActions.UPDATE_CAP_CANDIDATE_RESERVATION, capCourseReservationUpdate),
    yield takeEvery(capcourseActions.UPDATE_CAP_CANDIDATE_ACADEMIC, capCourseAcademicUpdate),
    yield takeEvery(capcourseActions.UPDATE_CAP_CANDIDATE_UPLOADS, uploadCapDetailsCreation),
    yield takeEvery(capcourseActions.GET_CAP_MASTER_FIELDS, getCapMasterFields),

    yield takeEvery(capcourseActions.GET_CANDIDATE_CAP_REG_DETAILS, getCapRegistrationDetails),


  ]);
};

const getallcapCourse = function* () {
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/capcourseregistartion/coursemanagement/getallcapcoursedetails`
)
    );
    // console.log(result?.data?.data, "result");
    yield put({
      type: capcourseActions.SET_ALL_CAPCOURSE,
      payload: result?.data?.data ? result?.data?.data : [],
    });
  } catch (err) {}
};

const getscoredetails = function* (action) {
  // console.log("capcourseActions", action);
  const { payload } = action;

  try {
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/capcourseregistartion/coursemanagement/getallcapscoredetails`,
        payload
      )
    );
    // console.log(result?.data?.data?.data, result?.data?.data, "result");

    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
    }
    yield put({
      type: capcourseActions.SET_SCOREDETAILS,
      payload: result?.data?.data,
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
  } catch (err) {
    console.error("Error fetching score details:", err);
  }
};

const getcapcandidatedetails = function* (action) {
  // console.log("capcourseActions getcapcandidatedetails", action);
  const { payload } = action;

  try {
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/capcourseregistartion/coursemanagement/getcandidatedetails`,
        payload
      )
    );

    // console.log(result?.data?.data, "result");

    yield put({
      type: capcourseActions.SET_CAP_CANDIDATEDETAILS,
      payload: result?.data?.data,
    });
    
  } catch (err) {
    console.error("Error fetching score details:", err);
  }
};

const getcapcandidateaddressdetails = function* (action) {
  // console.log("capcourseActions getcapcandidateaddressdetails", action);
  const { payload } = action;

  try {
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/capcourseregistartion/coursemanagement/getcandidateaddress`,
        payload
      )
    );

    // console.log(result?.data?.data, "result");

    yield put({
      type: capcourseActions.SET_CAP_CANDIDATEADDRESSDETAILS,
      payload: result?.data?.data,
    });
  } catch (err) {
    console.error("Error fetching score details:", err);
  }
};

const getcapcandidatereservationdetails = function* (action) {
  // console.log("capcourseActions getcapcandidatereservationdetails", action);
  const { payload } = action;

  try {
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/capcourseregistartion/coursemanagement/getcandidatereservation`,
        payload
      )
    );

    // console.log(result?.data?.data, "result");

    yield put({
      type: capcourseActions.SET_CAP_CANDIDATERESERVATIONDETAILS,
      payload: result?.data?.data,
    });
  } catch (err) {
    console.error("Error fetching score details:", err);
  }
};

const getcapcandidateacademicdetails = function* (action) {
  // console.log("capcourseActions getcapcandidateacademicdetails", action);
  const { payload } = action;

  try {
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/capcourseregistartion/coursemanagement/getcandidateacademic`,
        payload
      )
    );

    // console.log(result?.data?.data, "result");

    yield put({
      type: capcourseActions.SET_CAP_CANDIDATEACADAMICDETAILS,
      payload: result?.data?.data,
    });
  } catch (err) {
    console.error("Error fetching score details:", err);
  }
};

const getcapcandidateuploaddetails = function* (action) {
  // console.log("capcourseActions getcapcandidateuploaddetails", action);
  const { payload } = action;

  try {
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/capcourseregistartion/coursemanagement/getcandidateupload`,
        payload
      )
    );

    // console.log(result?.data?.data, "result");

    yield put({
      type: capcourseActions.SET_CAP_CANDIDATEUPLOADDETAILS,
      payload: result?.data?.data,
    });
  } catch (err) {
    console.error("Error fetching score details:", err);
  }
};

const getCapCategories = function* () {
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/backoffice/cap-category`)
    );
    if (result) {
      yield put({
        type: capcourseActions.SET_CAP_CATEGORY,
        payload: result?.data?.result,
      });
    }
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {}
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getCapCandidateDocuments = function* (action) {
  const { payload } = action;

  try {
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/capcourseregistartion/coursemanagement/getcandidate-documents`,
        payload
      )
    );

    // console.log(result?.data?.data, "result");

    yield put({
      type: capcourseActions.SET_CAP_CANDIDATE_DOCUMENTS,
      payload: result?.data?.data,
    });
  } catch (err) {
    console.error("Error fetching score details:", err);
  }
};

const createCapUploadsDocuments = function* (data) {
  const { payload } = data;
  const { navigate, coursedocs, categorydocs, candidaturedocs, ...formDatas } =  payload;

  const formData = new FormData();

  for (let key in formDatas.data) {
    formData.append(key, formDatas.data[key]);
  }

   if (coursedocs) {
    Object.keys(coursedocs).forEach((docType) => {
      if (docType !== 'documenttype') {
        formData.append(`coursedocs`, coursedocs[docType]);
      } else {
        formData.append('documenttype', coursedocs[docType]);
      }
    });
  }

  if (categorydocs) {
    Object.keys(categorydocs).forEach((docType) => {
      if (docType !== 'documenttype') {
        formData.append(`categorydocs`, categorydocs[docType]);
      } else {
        formData.append('documenttype', categorydocs[docType]);
      }
    });
  }

  if (candidaturedocs) {
    Object.keys(candidaturedocs).forEach((docType) => {
      if (docType !== 'documenttype') {
        formData.append(`candidaturedocs`, candidaturedocs[docType]);
      } else {
        formData.append('documenttype', candidaturedocs[docType]);
      }
    });
  }

  
  try {
    const result = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_URL}/candidate/capcourseregistartion/coursemanagement/create-uploads-document`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }    )
    );

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });

    yield put({
      type: capcourseActions.GET_CAP_CANDIDATE_DOCUMENTS,
      payload: { 
        candidateid: payload?.data?.candidateid,
        capcourseid: payload?.data?.capcourseid 
      },
    });
    

    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
    

    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });

   
  } catch (err) {
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const removeCapUploadsDocuments = function* (data) {
  const { payload, capcourseid, candidateid } = data;


  try {
    const result = yield call(() =>
      axios.put(`${process.env.REACT_APP_API_URL}/candidate/capcourseregistartion/coursemanagement/remove/${payload?.capcandidatedocumentid}`,
        {
          documenttype: payload?.documenttype,
          userid: payload?.userid,
        }
      )
    );

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });

    yield put({
      type: capcourseActions.GET_CAP_CANDIDATE_DOCUMENTS,
      payload: { 
        candidateid: candidateid,
        capcourseid: capcourseid 
      },
    });

    

    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
    

    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });

   
  } catch (err) {
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};



const getCapCandidatures = function* () {
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/backoffice/cap-candidature`)
    );
    if (result) {
      yield put({
        type: capcourseActions.SET_CAP_CANDIDATURE,
        payload: result?.data?.result,
      });
    }
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    if (result?.data?.statusCode === 200) {
      // navigate(
      //   `/${sessionStorage.getItem("mhet_mst_project")}/cap-course-document-master?page=document-list`
      // );
      // yield put({ type: capRegistrationActions.GET_CAP_COURSE_DOCUMENT });
    }

    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};


const InsertCandidatedetails = function* (data) {
  const { payload } = data;
  const {
    capcourseid,
    candidateid,
    courseid,
    capcandidatureid,
    capcategoryid,
  } = payload;
  const result= axios.post(
    `${process.env.REACT_APP_API_URL}/candidate/capcourseregistartion/coursemanagement/getcandidaterequireddocument`,
    {
      capcourseid,
      candidateid,
      courseid,
      capcandidatureid,
      capcategoryid,
    }
  );
  // console.log(result,"result");
  
};
   



const capCoursePersonaldetailsUpdate = function* (data) {
  const { payload } = data;
  // const { navigate, statusForRedirect } = payload;


  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const profileSummary = yield select(
  (state) => state?.authReducer?.ProfileSummaryDetails
);  
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    ) || profileSummary[0]?.candidateid;
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/capcourseregistartion/coursemanagement/updatepersonaldetails/${candidateid}`,
        payload
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
delay(2000)
// console.log('payload?.capcourseid---',payload);

    yield put({
      type: capcourseActions.GET_CAP_CANDIDATEDETAILS,
      payload: {capcourseid:payload?.data?.capcourseid,candidateid:candidateid},
    });

    payload?.handleClose();
    // if (result?.data?.statusCode === 200) {
    //   if (statusForRedirect === 1) {
    //     navigate(
    //       `/${sessionStorage.getItem(
    //         "mhet_cnd_project"
    //       )}/course-registration?page=preview&courseid=${EncryptFunction(
    //         payload?.data?.courseid
    //       )}&coursename=${encodeURIComponent(payload?.data?.coursename)}`,
    //       {
    //         state: {
    //           courseid: payload?.data?.courseid,
    //           coursename: payload?.data?.coursename,
    //         },
    //       }
    //     );
    //   } else {
    //     navigate(
    //       `/${sessionStorage.getItem("mhet_cnd_project")}/course-registration?page=${
    //         payload?.nextPageName
    //       }`,
    //       {
    //         state: {
    //           courseid: payload?.data?.courseid,
    //           coursename: payload?.data?.coursename,
    //         },
    //       }
    //     );
    //   }
    //   // window.location.reload();
    // } else if (result?.data?.statusCode === 410) {
    //   yield put({
    //     type: commonActions.SET_ALERT,
    //     payload: {
    //       status: result?.data?.statusCode === 410 ? "success" : "failed",
    //       show: true,
    //       message: result?.data?.message,
    //     },
    //   });
    // }
  } catch (err) {
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};



const capCourseAddressUpdate = function* (data) {
  const { payload } = data;
  const {handleClose} = payload
  // const { navigate, statusForRedirect } = payload;


  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const profileSummary = yield select(
  (state) => state?.authReducer?.ProfileSummaryDetails
);  
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    ) || profileSummary[0]?.candidateid;
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/capcourseregistartion/coursemanagement/updateaddressdetails/${candidateid}`,
        payload
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
delay(2000)
// console.log('payload?.capcourseid---',payload);

    yield put({
      type: capcourseActions.GET_CAP_CANDIDATEADDRESSDETAILS,
      payload: {capcourseid:payload?.data?.capcourseid,candidateid:candidateid},
    });
// console.log('handleClose',handleClose);

    handleClose();
    // if (result?.data?.statusCode === 200) {
    //   if (statusForRedirect === 1) {
    //     navigate(
    //       `/${sessionStorage.getItem(
    //         "mhet_cnd_project"
    //       )}/course-registration?page=preview&courseid=${EncryptFunction(
    //         payload?.data?.courseid
    //       )}&coursename=${encodeURIComponent(payload?.data?.coursename)}`,
    //       {
    //         state: {
    //           courseid: payload?.data?.courseid,
    //           coursename: payload?.data?.coursename,
    //         },
    //       }
    //     );
    //   } else {
    //     navigate(
    //       `/${sessionStorage.getItem("mhet_cnd_project")}/course-registration?page=${
    //         payload?.nextPageName
    //       }`,
    //       {
    //         state: {
    //           courseid: payload?.data?.courseid,
    //           coursename: payload?.data?.coursename,
    //         },
    //       }
    //     );
    //   }
    //   // window.location.reload();
    // } else if (result?.data?.statusCode === 410) {
    //   yield put({
    //     type: commonActions.SET_ALERT,
    //     payload: {
    //       status: result?.data?.statusCode === 410 ? "success" : "failed",
    //       show: true,
    //       message: result?.data?.message,
    //     },
    //   });
    // }
  } catch (err) {
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const capCourseReservationUpdate = function* (data) {
  const { payload } = data;
  const {handleClose} = payload
  // const { navigate, statusForRedirect } = payload;


  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const profileSummary = yield select(
  (state) => state?.authReducer?.ProfileSummaryDetails
);  
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    ) || profileSummary[0]?.candidateid;
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/capcourseregistartion/coursemanagement/updatereservationdetails/${candidateid}`,
        payload
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
delay(2000)
// console.log('payload?.capcourseid---',payload);

    yield put({
      type: capcourseActions.GET_CAP_CANDIDATERESERVATIONDETAILS,
      payload: {capcourseid:payload?.data?.capcourseid,candidateid:candidateid},
    });
// console.log('handleClose',handleClose);

    handleClose();
    // if (result?.data?.statusCode === 200) {
    //   if (statusForRedirect === 1) {
    //     navigate(
    //       `/${sessionStorage.getItem(
    //         "mhet_cnd_project"
    //       )}/course-registration?page=preview&courseid=${EncryptFunction(
    //         payload?.data?.courseid
    //       )}&coursename=${encodeURIComponent(payload?.data?.coursename)}`,
    //       {
    //         state: {
    //           courseid: payload?.data?.courseid,
    //           coursename: payload?.data?.coursename,
    //         },
    //       }
    //     );
    //   } else {
    //     navigate(
    //       `/${sessionStorage.getItem("mhet_cnd_project")}/course-registration?page=${
    //         payload?.nextPageName
    //       }`,
    //       {
    //         state: {
    //           courseid: payload?.data?.courseid,
    //           coursename: payload?.data?.coursename,
    //         },
    //       }
    //     );
    //   }
    //   // window.location.reload();
    // } else if (result?.data?.statusCode === 410) {
    //   yield put({
    //     type: commonActions.SET_ALERT,
    //     payload: {
    //       status: result?.data?.statusCode === 410 ? "success" : "failed",
    //       show: true,
    //       message: result?.data?.message,
    //     },
    //   });
    // }
  } catch (err) {
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};
const capCourseAcademicUpdate = function* (data) {
  const { payload } = data;
  const {handleClose} = payload
  // const { navigate, statusForRedirect } = payload;


  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const profileSummary = yield select(
  (state) => state?.authReducer?.ProfileSummaryDetails
);  
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    ) || profileSummary[0]?.candidateid;
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/capcourseregistartion/coursemanagement/updateacademicdetails/${candidateid}`,
        payload
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
delay(2000)
// console.log('payload?.capcourseid---',payload);

    yield put({
      type: capcourseActions.GET_CAP_CANDIDATEACADAMICDETAILS,
      payload: {capcourseid:payload?.data?.capcourseid,candidateid:candidateid},
    });
// console.log('handleClose',handleClose);

    handleClose();
    // if (result?.data?.statusCode === 200) {
    //   if (statusForRedirect === 1) {
    //     navigate(
    //       `/${sessionStorage.getItem(
    //         "mhet_cnd_project"
    //       )}/course-registration?page=preview&courseid=${EncryptFunction(
    //         payload?.data?.courseid
    //       )}&coursename=${encodeURIComponent(payload?.data?.coursename)}`,
    //       {
    //         state: {
    //           courseid: payload?.data?.courseid,
    //           coursename: payload?.data?.coursename,
    //         },
    //       }
    //     );
    //   } else {
    //     navigate(
    //       `/${sessionStorage.getItem("mhet_cnd_project")}/course-registration?page=${
    //         payload?.nextPageName
    //       }`,
    //       {
    //         state: {
    //           courseid: payload?.data?.courseid,
    //           coursename: payload?.data?.coursename,
    //         },
    //       }
    //     );
    //   }
    //   // window.location.reload();
    // } else if (result?.data?.statusCode === 410) {
    //   yield put({
    //     type: commonActions.SET_ALERT,
    //     payload: {
    //       status: result?.data?.statusCode === 410 ? "success" : "failed",
    //       show: true,
    //       message: result?.data?.message,
    //     },
    //   });
    // }
  } catch (err) {
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};







const uploadCapDetailsCreation = function* (action) {
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  const { payload } = action;
  const { navigate, editStatus, coursename, courseid,handleClose } = payload;
  const fileType = payload?.data?.filetype;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const formData = new FormData();
    const photoFile = new File(
      [payload.data.photofilename],
      `${candidateidid}_photo.jpeg`,
      { type: "image/jpeg" }
    );
    const signFile = new File(
      [payload.data.signfilename],
      `${candidateidid}_signature.jpeg`,
      {
        type: "image/jpeg",
      }
    );
    const documentFile = new File(
      [payload.data.documentfilename],
      payload?.data?.documentfilename?.name,
      {
        type:
          fileType == "pdf"
            ? "application/pdf"
            : fileType == "jpg"
            ? "image/jpeg"
            : fileType == "png"
            ? "image/png"
            : fileType == "docx"
            ? "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            : fileType === "doc"
            ? "application/msword"
            : "",
      }
    );
    const operation = payload.data.operation;
    const candidateid = payload.data.candidateid;
    const courseid = payload.data.courseid;
    const documentid = payload.data.documentid;
    const status = payload.data.status;
    const capcourseid = payload.data.capcourseid;


    formData.append(
      "photofilename2",
      payload?.data?.photofilename ? photoFile : ""
    );
    formData.append("signfilename", payload.data.signfilename ? signFile : "");
    formData.append(
      "documentfilename",
      payload.data.documentfilename ? documentFile : ""
    );

    formData.append(
      "photoUrl",
      payload?.data?.photofilename ? "" : payload?.data?.photoUrl
    );
    formData.append(
      "signUrl",
      payload?.data?.signfilename ? "" : payload?.data?.signUrl
    );
    formData.append(
      "docUrl",
      payload?.data?.documentfilename ? "" : payload?.data?.docUrl
    );

    formData.append(
      "photoname",
      payload?.data?.photoname ? payload?.data?.photoname : ""
    );
    formData.append(
      "signname",
      payload.data.signname ? payload.data.signname : ""
    );
    formData.append(
      "docname",
      payload.data.docname ? payload.data.docname : ""
    );

    formData.append("operation", operation);
    formData.append("candidateid", candidateid);
    formData.append("documentid", documentid);
    formData.append("status", status);
    formData.append(
      "frompreview",
      payload?.data?.fromPreview ? payload?.data?.fromPreview : "false"
    );
    formData.append("filetype", fileType ? fileType : "");
    formData.append("capcourseid", capcourseid);
    formData.append("courseid", courseid);


    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/capcourseregistartion/coursemanagement/uploads/${candidateidid}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
    );
    yield delay(2000);

    if (result?.data?.statusCode === 200) {
      handleClose();
    
    }
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: payload?.data?.fromPreview ? false : true,
        message: payload?.data?.fromPreview ? "" : result?.data?.message,
      },
    });

    yield put({
      type: capcourseActions.GET_CAP_CANDIDATEUPLOADDETAILS,
      payload: { 
        candidateid: candidateid,
        capcourseid: capcourseid 
      },
    });

    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
  } catch (err) {
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};









const getCapMasterFields = function* (data) {
  const { payload } = data;

  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/master/coursemanagement/form/field/cap/${payload?.data?.courseid}`
      )
    );
    yield put({
      type: candidatesActions.SET_MASTER_FIELDS,
      payload: result?.data?.statusCode === 200 ? result?.data?.result : [],
    });
  } catch (err) {
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};


const getCapRegistrationDetails = function* (data) {
  const { payload } = data;

  

  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/capcourseregistartion/coursemanagement/get_candidate_reg_details`,
        payload
      )
    );
    yield put({
      type: capcourseActions.SET_CANDIDATE_CAP_REG_DETAILS,
      payload: result?.data?.data,
    });
  } catch (err) {
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};





export default capcoursesaga;
